import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { environment } from "src/environments/environment";
import { GenericRepository } from "src/app/repositories/generic-repository/GenericRepository";
import { IProductRepository } from "./IProductRepository";
import { Product } from "src/app/models/Production/Products";

@Injectable({
  providedIn: 'root'
})
export class ProductRepository
  extends GenericRepository<Product>
  implements IProductRepository {

  constructor(protected _http: HttpClient) {
    super(_http, 'api/products', environment.urlAddress);
  }

  GetAll(
    currentPage: number,
    recordsPerPage: number,
    filterText: string
  ): Observable<any> {

    filterText = filterText.split('/').join('~');

    if (!filterText || filterText.trim() === "") {
      filterText = "";
    }

    return this.Get(
      'SelectAll/' + currentPage + '/' + recordsPerPage + '/' + filterText
    );
  }
}